import { useState } from 'react';
import { getFullUrl } from '../utils/utils';

export const useNewsletterApi = () => {
  const [loading, setLoading] = useState(false);

  const submitNewsletter = async ({ email }) => {
    setLoading(true);

    const leadUrl = '/api/v5/sailthru/reoptin';
    const apiEndpoint = getFullUrl(leadUrl);

    try {
      const response = await fetch(apiEndpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          brand_id: window.gon.current_brand,
          email: email,
          source: 'Newsletter'
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || `Error: ${response.status}`);
      }

      return {
        success: true,
        message: data.message || 'Email submitted successfully!',
      };
    } catch (error) {
      const errorMessage = error.message === 'email is already used'
        ? error.message
        : 'Something went wrong. Please try again.';

      return { success: false, message: errorMessage };
    } finally {
      setLoading(false);
    }
  };

  return { submitNewsletter, loading };
};
